// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3emQj","filesListContainer":"PosDisputesFiles_filesListContainer__F7dmb","filesButton":"PosDisputesFiles_filesButton__2fCxW"};